import { useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import CartContext from "../../context/CartContext";

// Função para formatar o preço corretamente
const formatPrice = (price) => {
  return Number(price || 0).toLocaleString("pt-AO", {
    style: "currency",
    currency: "AOA",
    minimumFractionDigits: 2,
  });
};
function calcularDesconto25(preco) {
  const desconto = preco * 0.25;
  return desconto;
}
const CheckoutPage = () => {
  const { cart, adicionar25Porcento } = useContext(CartContext); // puxando a função do contexto
  const navigate = useNavigate();

  // Considera quantidade no cálculo total com acréscimo de 25%
  const totalPrice = cart.reduce((acc, item) => {
    const qty = item.quantity || 1;
    const precoComAcrescimo = (Number(item.preco_com_iva || 0));
    return acc + precoComAcrescimo * qty;
  }, 0);

  const handleConfirm = () => {
    navigate("/pagamento"); // redireciona para a página de entrega
  };

  return (
    <div className="container mt-4" style={{ marginTop: "30px" }}>
      <h2 className="text-center mb-4">Finalizar Compra</h2>
      {cart.length === 0 ? (
        <div className="text-center">
          <h5>Seu carrinho está vazio.</h5>
          <Link to="/" className="btn btn-primary mt-3">Continuar Comprando</Link>
        </div>
      ) : (
        <div className="card p-3 shadow">
          <h4>Resumo da Compra</h4>
          {cart.map((product) => {
            const precoUnitarioComAcrescimo = adicionar25Porcento(Number(product.preco_com_iva || 0));
            const quantidade = product.quantity || 1;
            return (
              <div
                key={product.id}
                className="d-flex justify-content-between align-items-center border-bottom py-2"
              >
                <div>
                  <h5>{product.descricao}</h5>
                  <p>
                    Quantidade: {quantidade} <br />
                    Preço unitário: {formatPrice(Number(product.preco_com_iva)+calcularDesconto25(product.preco_com_iva))} <br />
                    Subtotal: {formatPrice((Number(product.preco_com_iva)+calcularDesconto25(product.preco_com_iva)) * quantidade)}
                  </p>
                </div>
              </div>
            );
          })}
          <hr />
          <div className="text-end">
            <h4>Total: {formatPrice(totalPrice+calcularDesconto25(totalPrice))}</h4>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <Link to="/" className="btn btn-secondary">
                Continuar a Comprar
              </Link>
              <button className="btn btn-success" onClick={handleConfirm}>
                Finalizar Compra
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutPage;
